/* Progressive enhancement only: no uploads, network calls or email sending. */
(() => {
  if (document.documentElement.dataset.lapselleHvBound) return;
  document.documentElement.dataset.lapselleHvBound = 'true';

  const updateProductLink = (link) => {
    const product = link.closest('product-info');
    if (!product) return;
    const destination = new URL(link.href, window.location.origin);
    const variantId = product.querySelector('product-form form input[name="id"]')?.value;
    if (variantId && /^\d+$/.test(variantId)) destination.searchParams.set('variantti', variantId);
    const choices = Array.from(product.querySelectorAll('variant-selects select, variant-selects input[type="radio"]:checked'))
      .map((el) => el.tagName === 'SELECT' ? el.selectedOptions[0]?.textContent?.trim() : el.value)
      .filter(Boolean);
    if (choices.length) destination.searchParams.set('valinta', choices.join(' / '));
    link.href = destination.href;
  };

  ['click', 'auxclick', 'focusin', 'pointerover'].forEach((type) => {
    document.addEventListener(type, (event) => {
      const link = event.target.closest?.('[data-hv-product-link]');
      if (link) updateProductLink(link);
    });
  });

  const setupService = () => {
    const service = document.querySelector('[data-hv-service]');
    if (!service) return;
    const params = new URLSearchParams(window.location.search);
    const clean = (value, max) => (value || '').replace(/[\r\n\u0000-\u001f\u007f]/g, ' ').slice(0, max);
    const title = clean(params.get('tuote'), 240);
    const choice = clean(params.get('valinta'), 240);
    const path = params.get('polku') || '';
    const variantId = params.get('variantti') || '';
    let productUrl = '';
    // Never turn an arbitrary query-string URL into a link or email destination.
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*$/i.test(path)) {
      const url = new URL(path, window.location.origin);
      if (/^\d+$/.test(variantId)) url.searchParams.set('variant', variantId);
      productUrl = url.href;
    }
    const productLine = title && productUrl
      ? title + (choice && choice !== 'Default Title' ? ' – ' + choice : '')
      : '';
    const context = service.querySelector('[data-hv-context]');
    if (context && productLine) {
      context.textContent = 'Pyyntöön mukaan: ' + productLine + '. Voit lisätä viestiin muitakin tuotteita ja toiveita.';
      context.hidden = false;
    }
    const body = [
      'Hei! Haluaisin havainnekuvan kotiimme.',
      '',
      'Tuotteet ja värit:',
      productLine,
      productLine ? productUrl : '',
      '',
      'Huoneen mitat (esim. seinän leveys ja vapaa lattiatila):',
      '',
      'Mihin tuotteet sijoitetaan / muut toiveet:',
      '',
      'Liitän huonekuvat tähän viestiin.'
    ].join('\r\n');
    service.querySelectorAll('[data-hv-email]').forEach((link) => {
      link.href = 'mailto:info@lapselle.fi?subject=' + encodeURIComponent('Havainnekuvapyyntö – Lapselle.fi')
        + '&body=' + encodeURIComponent(body);
    });
  };
  setupService();
  document.addEventListener('shopify:section:load', setupService);
})();
